
export default {
  props: {
    dark: {
      type: Boolean,
      default: false
    }
  },
  vessel: {
    bar: {
      $dark: {
        backgroundColor(value) {
          return value ? 'black' : 'white'
        },
        color(value) {
          return value ? 'white' : 'black'
        },
        borderTopWidth(value) {
          return value ? null : 1
        }
      },
      pinBottom: true,
      position: 'fixed',
      zIndex: 50,
      width: 'full',
      padding: 'sm',
      fontSize: 'sm'
    },
    link: {
      textDecoration: 'underline'
    }
  },
  data() {
    return {
      visible: false,
      showInfo: false,
      showDetails: {},
      checkColumns: {
        all: 3,
        md: 1
      },
      textColumns: {
        all: 4,
        md: 8
      },
      detailsColumns: {
        all: 10,
        md: 8
      }
    }
  },
  computed: {
    cookieTypes() {
      return [
        {
          name: 'essential',
          title: this.$t('site.basicCookies'),
          text: this.$t('site.basicCookiesText'),
          basic: 'check',
          all: 'check'
        },
        {
          name: 'marketing',
          title: this.$t('site.marketingCookies'),
          text: this.$t('site.marketingCookiesText'),
          basic: 'times',
          all: 'check'
        }
      ]
    }
  },
  methods: {
    onDetailsClick(type) {
      const value = this.showDetails[type.name]

      this.$set(this.showDetails, type.name, !value)
    },
    onAccept() {
      this.$tracker.optIn()
    },
    onAcceptBasic() {
      this.$tracker.optOut()
    },
    onInfoClick() {
      this.showInfo = true
    }
  },
  mounted() {
    this.visible = true
  }
}
